module.exports = __webpack_public_path__ + "04e39b69e4a48554591864b0837b8537.ttf";